<div class="card border-0 rounded-0">
  <div class="card-body">
    <div class="d-flex align-items-center justify-content-between gap-1 mb-3">
      <h6 class="card-title m-0">SIDEA - {{ data.label }}</h6>

      <p-toggleswitch
        [(ngModel)]="status"
        class="d-flex align-items-center justify-content-center"
        [style]="{ '--p-toggleswitch-checked-background': 'var(--bs-success)', '--p-toggleswitch-checked-hover-background': 'var(--bs-success)' }"
        (onChange)="switchShutdown()"
      />
    </div>

    <p-inputgroup>
      <p-iftalabel class="w-100">
        <input pInputText [(ngModel)]="this.cookie" class="w-100 h-50px" />
        <label>Cookies</label>
      </p-iftalabel>
      <p-button icon="bi bi-x-lg" styleClass="px-4 h-100 rounded-start-0 bg-body-secondary text-dark border-secondary-subtle border-start-0" (onClick)="this.cookie = ''" />
      <p-button icon="pi pi-save" class="ms-1" styleClass="px-4" (onClick)="setCookie()" />
    </p-inputgroup>

    <div class="d-flex gap-2 mt-2">
      <div class="card h-100 flex-fill">
        <div class="card-body p-2">
          <p-inputgroup>
            <p-iftalabel class="w-100">
              <input pInputText [value]="data.requestMade" class="w-100 h-80px border-0 fs-3 fw-medium shadow-none bg-transparent" [disabled]="true" />
              <label>Solicitudes realizadas</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>
      </div>
      <div class="card h-100 flex-fill">
        <div class="card-body p-2">
          <p-inputgroup>
            <p-iftalabel class="w-100">
              <input pInputText [(ngModel)]="this.requestIntervalLimit" class="w-100 h-80px border-0 fs-3 fw-medium shadow-none" />
              <label>Intervalo de solicitudes</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>
      </div>
      <div class="card h-100 flex-fill">
        <div class="card-body p-2">
          <p-inputgroup>
            <p-iftalabel class="w-100">
              <input pInputText [(ngModel)]="this.requestMadeLimit" class="w-100 h-80px border-0 fs-3 fw-medium shadow-none" />
              <label>Límite de solicitudes</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-end gap-1 mt-2">
      <p-button label="Resetear" severity="secondary" (onClick)="reset()" />
      @if (status !== true) {
        <p-button label="Eliminar" severity="danger" (onClick)="delete()" />
      }
    </div>
  </div>
</div>
